import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import { MensajeService } from './servicios/mensaje.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { environment } from 'src/environments/environment';
import {SharedModule} from './shared/shared.module';
declare var gtag;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
            standalone: true,
            imports: [SharedModule],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav: MatSidenav;
  mensaje: string;
  title = 'Portal';
  reason = '';
  timer: Observable<any>;
  subscription: Subscription;
  ingreso = false;
  showMensaje = false;

  constructor(private serviceMensaje: MensajeService, private router: Router, private bnIdle: BnNgIdleService) {

    // this.bnIdle.startWatching(300).subscribe((res) => {
    //   if (res) {
    //       localStorage.removeItem('currentUser');
    //       localStorage.removeItem('activeDirectoryUser');
    //       localStorage.removeItem('permits');
    //       alert("Sesión finalizada por inactividad");
    //       //this.router.navigate(['#']);
    //       location.reload();
    //   }
    // });

  }

  ngOnInit() {
    this.serviceMensaje.getMensaje().subscribe(mensaje => this.mensaje = mensaje);
    this.setTimer();
    this.setAnalytics();
  }

  public setTimer() {
    this.timer = timer(7000);
    this.subscription = this.timer.subscribe(() => {
      this.serviceMensaje.limpiarMensaje();
    });
  }

  ngOnDestroy(): void {
    this.serviceMensaje.limpiarMensaje();
  }

  setAnalytics() {
    gtag('config', `${environment.codigoAnalitycs}`);
  }

  close(reason: string) {
    this.serviceMensaje.limpiarMensaje();
    this.setTimer();
    this.reason = reason;
    this.sidenav.close();
  }
}